// extracted by mini-css-extract-plugin
module.exports = {"container":"_c0a40e7d","stoneCutContainer":"_f08e297c","label":"_2558cf3c","text":"_205edf47","count":"_d60a7eb9","input":"_d852e88c","checked":"_ad36cedd"};